import type { DocumentUploadedByTableCellFragment } from "../client/generated";
import { UserAvatar } from "../users/UserAvatar";
import { DocumentTableCell } from "./DocumentTableCell";

type Props = {
  fragment: DocumentUploadedByTableCellFragment;
};

export function DocumentUploadedByTableCell({ fragment }: Props) {
  return (
    <DocumentTableCell className="flex items-center gap-2">
      <UserAvatar className="size-6" fragment={fragment.uploadedBy} />
      <span>{fragment.uploadedBy.username}</span>
    </DocumentTableCell>
  );
}
